module.exports = __webpack_public_path__ + "static/media/ti2.e2e29c91.jpg";